module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/node_modules/core-js/modules/_fails.js
// module id = ../../../../core-js/modules/_fails.js
// module chunks = polyfills